// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const configurePlatform = (_params: {
  onTokenReceived: (token: string) => void
  onRegistrationError: (error: any) => void
  onNotificationReceived: (notification: any) => void
}) => {
  return
}
